import script from "./GoodAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodAdd.vue?vue&type=script&setup=true&lang=js"

import "./GoodAdd.vue?vue&type=style&index=0&id=7f8818f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8818f9"]])

export default __exports__